'use strict'
angular.module('webremote.applets', [])
require('./controller')
